import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core'

@Directive({
  selector: '[delayClick]',
  standalone: false,
})
export class DelayClickDirective {
  @Input() delay = 0
  @Output() delayClick = new EventEmitter()

  @HostListener('click', ['$event'])
  onClick(event) {
    if (this.delay) {
      setTimeout(() => this.delayClick.emit(event), this.delay)
    } else {
      this.delayClick.emit(event)
    }
  }
}
